export default __webpack_public_path__ + "static/media/cucumber.71c9d00d.PNG";